/* globals MapboxUserMenu */
import config from '../config';

function isProduction() {
  if (config.MBXXHR_ORIGIN === 'production') {
    return true;
  }
  return false;
}

export function loadUserMenu() {
  // We need to mount twice, for mobile and nonmobile, but only
  // call the callback once.
  MapboxUserMenu.initialize({
    elementId: 'mbx-user-menu-non-mobile',
    isProduction: isProduction()
  });
  MapboxUserMenu.initialize({
    elementId: 'mbx-user-menu-mobile',
    isProduction: isProduction()
  });
}
